
import {Bar} from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend, TimeScale,
} from 'chart.js';
import {useEffect, useState} from "react";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    TimeScale
);

export function BarChart({values, options, label="", color}){
    const [data, setData] = useState();

    useEffect(() => {
        let newData = {
            datasets: [{
                label: label,
                data: values,
                color: "white",
                backgroundColor: color,
                borderColor: color,
                borderWidth: 1
            }],
            labels: ["ÚLTIMA SEMANA", "ÚLTIMOS 15 DÍAS", "ÚLTIMO MES", "ÚLTIMOS 6 MESES"]
        }
        setData(newData);
    }, [values]);

    return <div style={{
        paddingTop: "40%",
        position: "relative",
        width: "100%"
    }}>
        <div style={{position: "absolute", top: 0, width:"100%", height: "100%"}}>
        {data && <Bar options={options} data={data}/>}
        </div>
    </div>
}